module.exports = __webpack_public_path__ + "static/media/figure7.2f356dcd.png";